import React, { useContext, useEffect, useRef, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { MeasurementBanner as MeasurementBannerContent } from 'pages/common/components/MeasurementBanner';
import { gaViewMeasurementBanner } from 'ga-events/ga-view-measurement-banner';
import { gaClickMeasurementBanner } from 'ga-events/ga-click-measurement-banner';
import { measurementAtom } from '../../store/measurement';
import { DataContext } from '../../../../entries/common/widgets/project-configuration/context';
import { getMeasurementBannerGaParams } from '../../helpers/get-measurement-banner-ga-params';

export const MeasurementBanner = () => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const measurement = useRecoilValue(measurementAtom);
  const data = useContext(DataContext);
  const gaParams = useMemo(
    () =>
      getMeasurementBannerGaParams({
        type: data?.type,
        catalogueLevel: data?.catalogueLevel,
        price: measurement.price,
      }),
    [data?.type, data?.catalogueLevel, measurement.price]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          gaViewMeasurementBanner(gaParams);
          // нужно вызывать только один раз, поэтому делаем unobserve после отправки GA ивента
          if (bannerRef.current) {
            observer.unobserve(bannerRef.current);
          }
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      if (bannerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(bannerRef.current);
      }
    };
  }, [gaParams]);

  const handleClickCallMaster = () => {
    gaClickMeasurementBanner(gaParams);
  };

  return (
    <div ref={bannerRef}>
      <MeasurementBannerContent
        priceMin={measurement.price!}
        serviceURL={measurement.serviceURL!}
        serviceName={measurement.title!}
        onClickCallMaster={handleClickCallMaster}
      />
    </div>
  );
};
